'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconClockCog, iconClockCogTag } from '@ni/nimble-components/dist/esm/icons/clock-cog';
import { wrap } from '../../utilities/react-wrapper';

export type { IconClockCog };
export { iconClockCogTag };
export const NimbleIconClockCog = wrap(IconClockCog);